import create from "zustand";
import { ApiError, AsyncStatus } from "../../store/types";
import { CurrentStep, Steps } from "./forms-import-stepper.types";

type Actions = {
  reset: () => void;
};

const initialState: FormsImportStepperState = {
  status: "idle",
  currentStep: {
    id: "instructions",
    index: 0,
    title: "Instructions",
  },
  steps: {
    credentials: {
      apiKey: "",
      customDomain: "",
      invalid: true,
    },
    formsImport: {
      userForms: [],
      invalid: true,
    },
    formsPlan: {
      importForms: [],
      forms: [],
    },
    importedForms: {
      importForms: [],
    },
  },
};

export const useFormsImportStepperState = create<
  FormsImportStepperState & Actions
>((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
}));

interface FormsImportStepperState {
  currentStep: CurrentStep;
  status: AsyncStatus;
  steps: Steps;
  error?: ApiError;
}
